module.exports = __webpack_public_path__ + "media/images/icons/user-cart-bded85335c09848675d74ac3da609da5.svg";